import axios from 'axios'

export const getBookedDates = (rideId) => {
    return new Promise((result, reject) => {
        axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + "/api/v1/rides/bookingDate",//159.89.236.159
            params: { id: rideId },
        }).then(
            (res) => {
                result(res);
            }
        ).catch(err => {
            reject(err)
        })
    })
}